import { VStack } from "@gluestack-ui/themed";
import { InputControlled } from "@repo/core/components/forms/InputControlled";
import { Text } from "@repo/core/components/core/Text";
import { SelectControlled } from "@repo/core/components/forms/SelectControlled";
import { InputTypeSelectControlled } from "@repo/core/components/forms/InputTypeSelect";
import { inputTypeOptions } from "@repo/core/screens/ProposalEffectiveFlows/Credit/PersonalDataForm/utils";
import { ProgressBar } from "@repo/core/components/layout/ProgressBar";
import { PageScaffold } from "@repo/core/components/layout/Scaffolds/PageScaffold";
import { ScaffoldFooter } from "@repo/core/components/layout/Scaffolds/components/ScaffoldFooter";

import { FidelityPersonalDataController } from "./controller";

const FidelityPersonalData = () => {
  const {
    control,
    handleOnSubmitForm,
    handleGoBack,
    handleClose,
    martialStatusOptions,
    professionOptions,
    isProfessionsLoading,
    isLoadingProposal,
    isSubmitting
  } = FidelityPersonalDataController();

  return (
    <PageScaffold
      onBackPress={handleGoBack}
      showBackButtonOnWeb
      onPressRightIcon={handleClose}
      rightWebLabel="Fechar"
      title="Proposta de Fidelidade"
      isLoading={isLoadingProposal}
      loadingTitle="Carregando dados da proposta"
      loadingDescription="Aguarde enquanto buscamos as informações..."
      footerContent={
        !isLoadingProposal ? (
          <ScaffoldFooter
            primaryText="Continuar"
            primaryAction="primary"
            primaryOnPress={handleOnSubmitForm}
            primaryIsLoading={isSubmitting}
            primaryIsDisabled={isSubmitting}
          />
        ) : undefined
      }
    >
      <VStack w="$full" gap="$4" pb="$4">
        <ProgressBar progress={50} />
        <Text>Dados pessoais adicionais:</Text>

        <InputControlled
          control={control}
          isRequired
          keyboardType="number-pad"
          label="Data de Nascimento"
          mask="date"
          name="birthday"
          placeholder="dd/mm/aaaa"
          useMaskValue
          enterKeyHint="done"
        />

        <InputTypeSelectControlled
          control={control}
          inputTypes={inputTypeOptions}
          isRequired
          label="Gênero"
          name="gender"
        />
        <SelectControlled
          control={control}
          label="Estado civil"
          name="martialStatus"
          options={martialStatusOptions ?? []}
          placeholder="Selecione o estado civil"
        />

        <SelectControlled
          control={control}
          label="Profissão"
          name="profession"
          placeholder="Selecione a profissão"
          options={professionOptions ?? []}
          isLoading={isProfessionsLoading}
        />
      </VStack>
    </PageScaffold>
  );
};

export default FidelityPersonalData;
